<template>
    <div ref="map" id="mapCanvas" class="map"></div>
</template>

<script>
import { Loader } from "@googlemaps/js-api-loader"

export default {
    props: {
        data: {
            required: true,
            type: Array
        }
    },
    data() {
        return {
            key: 'AIzaSyA4YZBHBGWNlrV-ONhhJbe8_ep0gmP1DkM',

            issue_type: {
                routine_maintenance: 'Routine Maintenance',
                electrical_maintenance: 'Electrical Maintenance',
                major_maintenance: 'Major Maintenance',
                highway: 'Corrective Maintenance',
                road_user_accident: 'Road User Accident',
                occupational: 'Occupational',
                hazard: 'Hazard',
                dead_animal_debris_removal: 'Dead Animal Debris Removal',
                vehicle_breakdown: 'Vehicle Breakdown',
                traffic_violation: 'Traffic Violation',
                unauthorised_parking: 'Unauthorised Parking',
                unauthorised_access: 'Unauthorised Access',
                unauthorised_media_cut: 'Unauthorised Median Cut',
                material_damage: 'Material Damage',
                other: 'Other',
                enroachment_row: 'Enroachment Row',
            },

            dpr_module_key: {
                mm_bituminous_concrete_overlay: 'Bituminous Concrete Overlay',
                mm_dense_bituminous_concrete_overlay: 'Dense Bituminous Concrete Overlay',
                mm_milling: 'Milling',
                mm_thermoplastic_road_marking: 'Thermoplastic RoadMarking',
                mm_shoulder_raising: 'Shoulder Raising',
                mm_road_sruds_fixing: 'RoadSruds Fixing',
                mm_kerb_topping: 'KerbTopping',
                mm_kerb_painting: 'KerbPainting',
                mm_microsurfacing: 'MicroSurfacing',
                mm_tack_coat: 'Tack Coat',
            },
        }
    },
    mounted() {
        this.load_maps()
    },
    watch: {
        data: {
            deep: true,
            handler(newV, oldV) {
                if(newV==oldV) return
                this.load_maps()
            }
        },
    },
    methods: {
        initMap() {
            let bounds = new google.maps.LatLngBounds();
            
            // Place each marker on the map  
            for(let i = 0; i < this.data.length; i++ ) {

                if (this.data[i].location_latitude && this.data[i].location_longitude) { 

                    let position = new google.maps.LatLng(this.data[i].location_latitude, this.data[i].location_longitude);
                    bounds.extend(position);
                    this.marker = new google.maps.Marker({
                        position: position,
                        map: this.map,
                        title: this.get_title(this.data[i]),
                        draggable: false
                    });
    
                    this.marker.addListener('click', () => {
                        this.$emit('open_map_popup', this.data[i])
                    })
    
                    // Center the map to fit all markers on the screen
                    this.map.fitBounds(bounds);
                }
            }
        },
        load_maps() {
            const loader = new Loader({
                apiKey: this.key,
                version: "weekly"
            });
            
            return new Promise( (resolve, reject) => {
                loader.load().then(() => {
                    let map_options = {
                        zoom: 8,
                        controlSize: 25,
                        fullscreenControl: false,
                        streetViewControl: false
                    }
    
                    this.map = new google.maps.Map(this.$refs['map'], map_options);
                    this.initMap()
                    resolve()
                });
            })
        },
        get_title(data) {

            if(data.issue_type == 'major_maintenance' && data.module_key) {
                return `(Id: #${data.secondary_id}), Type: ${this.dpr_module_key[data.module_key]}, SPV: ${data.organisation.name}`

            } else {
                return `(Id: #${data.secondary_id}), Type: ${this.issue_type[data.issue_type]}, SPV: ${data.organisation.name}`
            }
        }
    }
}
</script>

<style lang="scss">
    #mapCanvas{
        width: 100%;
        height: 400px;
    };

    .map {
        height: 250px;
    };

    .tooltip-actions {
      .con-vs-tooltip {
        display: inline-flex;
      }
    }
</style>
